export default {
  bind(el, bindings) {
    // 所有权限
    const permissions = JSON.parse(localStorage.getItem('permissions'))
    // // 需要的权限
    const needPermission = bindings.value
    const hasPermission = permissions.includes(needPermission)
    if (!hasPermission) {
      el.style.display = 'none'
      setTimeout(() => {
        el.parentNode.removeChild(el)
      }, 1000)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/has.js